import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import './App.css'; // Ensure styles are imported

const HomePage: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="home-page-container page-container">
      <header className="home-header">
        {/* <h1 className="page-title">{t('home_welcome_title')}</h1>
        <p className="home-subtitle">{t('home_branch_info')}</p> */}
        <div className="contact-info">
          <p>{t('home_tel')}</p>
          <p>{t('home_fax')}</p>
        </div>
      </header>

      <section className="home-section about-association">
        <h2>{t('home_association_title')}</h2>
        <p>{t('home_association_description')}</p>
      </section>

      <section className="home-section mission-goals">
        <h2>{t('home_mission_title')}</h2>
        <p>{t('home_mission_description')}</p>
        <p>{t('home_mission_paragraph')}</p>
      </section>

      <section className="home-section activities-projects">
        <h2>{t('home_activities_title')}</h2>
        <ol className="activities-list">
          <li>
            <h4>{t('home_activity_cultural_title')}</h4>
            <p>{t('home_activity_cultural_desc')}</p>
          </li>
          <li>
            <h4>{t('home_activity_identity_title')}</h4>
            <p>{t('home_activity_identity_desc')}</p>
          </li>
          <li>
            <h4>{t('home_activity_lobbying_title')}</h4>
            <p>{t('home_activity_lobbying_desc')}</p>
          </li>
        </ol>
      </section>
    </div>
  );
}

export default HomePage; 